<template>
  <div class="verion">
    <div class="verion-background">
      <div class="cardnber-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        欧堡利亚医院
      </div>
      <div class="verion-irmaon">
        <div class="verion-irmaon-camber verion-irmaon-soline">
          <span>卡号</span>
          <input type="Number" v-model="vecrmb" placeholder="请输入体检卡号" @input="vemdnr()">
          <img src="../../public/obraoag/verionsw.png" alt="">
        </div>
        <div class="verion-irmaon-camber">
          <span>密码</span>
          <input type="password" v-model="verpsd" placeholder="请输入体检卡密码" @input="verasd()">
        </div>
      </div>
      <button class="verion-crsion" @click="vecosu()">确定</button>
    </div>
    <!-- 错误提示 -->
    <Errosage :style="'display:' + verierge" :txtrro="this.veersg"></Errosage>
    <!-- 成功提示 -->
    <Succtips :style="'display:' + verisups"></Succtips>
    <!-- 网络不佳 -->
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      vecrmb: '',
      verpsd: '',
      verierge: 'none',
      verisups: 'none',
      veersg: ''
    }
  },
  created () {
    
  },
  mounted () {
    
  },
  methods: {
    // 获取用户输入的卡号
    vemdnr(){
      console.log(this.vecrmb);
    },
    // 获取用户输入的密码
    verasd(){
      console.log(this.verpsd);
    },
    // 点击确认触发
    vecosu(){
      if(this.vecrmb == ''){
        this.veersg = '卡号不能为空';
        this.verierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.verierge = 'none';
        },1200)
      }else if(this.verpsd == ''){
        this.veersg = '卡密码不能为空';
        this.verierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.verierge = 'none';
        },1200)
      }else{
        this.$axios.post('https://wd.obraopay.com/zsk/wx/projectcardOne',this.$qs.stringify({
          CARD_NUMBER: this.vecrmb,
          PASSWORD: this.verpsd
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.flag == '0'){
            this.verisups = 'block';
            const _this = this;
            setTimeout(function(){
              _this.verisups = 'none';
              _this.$router.push({name: 'makent',query: {ventam: res.data.data.CARD_NAME,veprum: res.data.data.CARD_NUMBER,vecras: res.data.saveUpdate,vemoid: res.data.appData.ID,veapus: res.data.data.STATES,veatnm: res.data.appData.NAME,vereul: res.data.appData.APPOINTMENT_DATE,vebier: res.data.appData.USERNAME}});
            },1200)
          }else{
            this.veersg = res.data.msg;
            this.verierge = 'block';
            const _this = this;
            setTimeout(function(){
              _this.verierge = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/verion.css";
</style>